import { createAction } from 'typesafe-actions';
import { IBaseReservation } from '../../interfaces';

const FETCH_RESERVATION = 'FETCH_RESERVATION';

export const fetchReservation = createAction(FETCH_RESERVATION, (restaurantId: string, token: string) => {
    return { restaurantId, token };
})();

const RESERVATION_ERROR = 'RESERVATION_ERROR';

export const reservationError = createAction(RESERVATION_ERROR, (error: any) => ({ error }))();

const SET_RESERVATION = 'SET_RESERVATION';

export const setReservation = createAction(SET_RESERVATION, (reservation: IBaseReservation) => ({ reservation }))();

const CANCEL_RESERVATION = 'CANCEL_RESERVATION';

export const cancelReservation = createAction(CANCEL_RESERVATION, (restaurantId: string, token: string) => ({
    restaurantId,
    token,
}))();

const CANCEL_SUCCESS = 'CANCEL_SUCCESS';

export const cancelSuccess = createAction(CANCEL_SUCCESS)();
